import { render, staticRenderFns } from "./NotesPopup.vue?vue&type=template&id=aac10572&scoped=true&"
import script from "./NotesPopup.vue?vue&type=script&lang=js&"
export * from "./NotesPopup.vue?vue&type=script&lang=js&"
import style0 from "./NotesPopup.vue?vue&type=style&index=0&id=aac10572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac10572",
  null
  
)

export default component.exports